<template>
  <div class="container-fluid">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'ProfileLayout'
}
</script>

<style scoped>
</style>
